import React, { Component } from "react";
import PropTypes from "prop-types";
import api from "application/api/api";
import externalApi from "application/api/external-api";
import { STORE_ID, MARKET_ID, prod } from "application/constants/app-constants";
import Form from "form/components/form";
import {
  isNil,
  length,
  mergeRight,
  split,
  clone,
  includes,
  isEmpty,
} from "ramda";
import { adaptFormToBack } from "form/adapter/adaptFormToBack";
import {
  getNavLocale,
  getMarket,
  parseAvailableData,
  getFormId,
  getTokenId,
  parseToAppointment,
  getSiteId,
  getSections,
  isFromGermany,
  getAppointmentType,
  getStlocId,
  getLangToSend,
} from "application/functions";
import withSizeWindow from "application/hoc/with-size-window";
import errorBoundary from "application/hoc/error-boundary";
// import { mock1, mock2, mock3 } from "application/constants/mock";

class FormPage extends Component {
  static propTypes = {
    size: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.searchForm = this.searchForm.bind(this);
    this.setStructure = this.setStructure.bind(this);
    this.getLocaleHeader = this.getLocaleHeader.bind(this);
    this.getAllHeaders = this.getAllHeaders.bind(this);
    this.handleForm = this.handleForm.bind(this);
    this.handleResolve = this.handleResolve.bind(this);
    // this.handleInetgecoApi = this.handleInetgecoApi.bind(this);
    this.handleExternalApi = this.handleExternalApi.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.setAvaiability = this.setAvaiability.bind(this);
    this.urlParams = new URLSearchParams(window.location.search);
    this.siteId = getSiteId();
    this.formId = getFormId();
    this.tokenId = getTokenId();
    this.appointmentType = getAppointmentType();
    this.state = {
      loading: this.handleValidUrl(),
      structure: null,
      showSuccess: false,
      showError: isNil(this.formId) || isNil(this.tokenId),
      disableAfterSubmit: false,
      locale: getNavLocale(),
      showDate: false,
      showTime: true,
      availability: [],
      showTelephoneError: false,
      showEmailError: false,
      showMessageError: "",
      token: null,
      stlocId: getStlocId(),
    };
  }

  componentDidMount() {
    if (isNil(this.state.structure)) {
      if (prod) {
        this.searchToken();
      } else {
        this.searchForm();
      }
      this.setAvaiability();
    }
  }

  handleValidUrl() {
    let result = false;
    if (!isNil(this.formId)) {
      result = true;
    } else {
      const aPathName = split("/", window.location.pathname);
      result = aPathName[length(aPathName) - 6] === "t";
    }
    return result;
  }

  searchForm() {
    const { token } = this.state;
    const formId = (token && token.entityId) || this.formId;
    api
      .searchForm(formId, this.getAllHeaders())
      .then((data) => {
        if (!isNil(data.data) && !isNil(data.data.form)) {
          this.setStructure(data.data.form);
        } else {
          this.setState({ showError: true, loading: false });
        }
      })
      .catch(() => this.setState({ showError: true, loading: false }));
  }

  searchToken() {
    api
      .searchToken(this.tokenId, this.getAllHeaders())
      .then((data) => this.setToken(data.data.token))
      .catch(() => this.setState({ showError: true, loading: false }));
  }

  setToken(value) {
    if (isNil(value)) {
      this.setState({ showError: true, loading: false });
      return;
    }
    this.setState({ token: value }, () => this.searchForm());
  }

  setStructure(value) {
    this.setState({ structure: value, loading: false });
  }

  getLocaleHeader() {
    return {
      "Accept-language": isNil(getLangToSend())
        ? getNavLocale()
        : getLangToSend(),
    };
  }

  getAllHeaders() {
    const siteHeader = { "X-Site-Id": this.siteId };
    const requiredHeaders = mergeRight(siteHeader, this.getLocaleHeader());
    const tokenHeader = { auth_token: this.tokenId };
    return mergeRight(requiredHeaders, tokenHeader);
  }

  handleForm(value) {
    this.setState({
      disableAfterSubmit: true,
      showTelephoneError: false,
      showEmailError: false,
      showMessageError: "",
    });

    this.handleExternalApi(value);
  }

  // handleInetgecoApi(value) {
  //   const { structure, locale } = this.state;
  //   let inetgecoValue = {
  //     legal_acceptation: { value: value.legal_acceptation },
  //   };

  //   const germanValue = {};
  //   if (isFromGermany()) {
  //     const { street, zip_code, city, covid_positive } = value;
  //     germanValue.street = { value: street };
  //     germanValue.zip_code = { value: zip_code };
  //     germanValue.city = { value: city };
  //     germanValue.covid_positive = { value: covid_positive };
  //   }

  //   const title = value.email;
  //   api
  //     .createForm(
  //       {
  //         content: adaptFormToBack(
  //           { ...inetgecoValue, ...germanValue },
  //           structure,
  //           locale,
  //           title
  //         ),
  //       },
  //       this.getAllHeaders()
  //     )
  //     .then((inetgecoData) => this.handleResolve(value, inetgecoData))
  //     .catch(() => this.setState({ showError: true }));
  // }

  handleExternalApi(value) {
    const { availability } = this.state;
    const stlocId = this.state.stlocId ? this.state.stlocId : getStlocId();
    const sections = getSections(availability);

    const newValue = clone(value);

    if (length(sections) < 2) {
      newValue.section = length(sections) === 1 ? sections[0] : null;
    }

    externalApi
      .setAppointment(
        getMarket(),
        parseToAppointment(newValue, this.appointmentType, stlocId)
      )
      .then((data) => this.handleSuccess())
      .catch((err) => {
        if (
          includes(
            "Customer should have a valid phone",
            err?.response?.data?.description ?? ""
          )
        ) {
          this.setState({
            disableAfterSubmit: false,
            showTelephoneError: true,
          });
        } else if (
          includes(
            "Customer should have a valid email",
            err?.response?.data?.description ?? ""
          )
        ) {
          this.setState({
            disableAfterSubmit: false,
            showEmailError: true,
          });
        } else {
          const text = split("Cause: ", err?.response?.data?.description ?? "");
          this.setState({
            showMessageError:
              text?.[1] ?? err?.response?.data?.description ?? "",
          });
        }
      });
  }

  handleResolve(formValue, inetgecoData) {
    if (isNil(inetgecoData?.errors)) {
      this.handleExternalApi(formValue);
    } else {
      this.setState({ showError: true });
    }
  }

  handleSuccess() {
    this.setState({ showSuccess: true });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  handleStore(value) {
    if (!isNil(value) && !isEmpty(value)) {
      const stlocId = getStlocId() !== "" ? getStlocId() : value[0];
      const params = {
        appointmentType: getAppointmentType(),
        stlocId,
      };
      const market = getMarket();
      externalApi
        .getAvailability(market, params)
        .then((res) => {
          const availability = parseAvailableData(res.data);
          this.setState({
            showDate: true,
            availability,
            stlocId,
          });
        })
        .catch((err) => this.setState({ showError: true }));
    } else {
      this.setState({ showDate: false });
    }
  }

  setAvaiability() {
    const stlocId = getStlocId() !== "" ? getStlocId() : MARKET_ID;
    const params = { appointmentType: this.appointmentType, stlocId };
    externalApi
      .getAvailability(params)
      .then((res) => {
        const availability = parseAvailableData(res.data);
        this.setState({
          showDate: true,
          availability,
        });
      })
      .catch((err) => this.setState({ showError: true }));
  }

  render() {
    const {
      structure,
      showSuccess,
      showError,
      locale,
      loading,
      disableAfterSubmit,
      showDate,
      showTime,
      availability,
      showTelephoneError,
      showEmailError,
      showMessageError,
      stlocId,
    } = this.state;

    if (loading) return null;

    return (
      <Form
        structure={structure}
        submit={(value) => this.handleForm(value)}
        locale={locale}
        showSuccess={showSuccess}
        showError={showError}
        disableAfterSubmit={disableAfterSubmit}
        size={this.props.size}
        showDate={showDate}
        handleStore={(v) => this.handleStore(v)}
        showTime={showTime}
        availability={availability}
        showTelephoneError={showTelephoneError}
        showEmailError={showEmailError}
        showMessageError={showMessageError}
        stlocId={stlocId}
      />
    );
  }
}

export default withSizeWindow(errorBoundary(FormPage));
